import Button from "components/button";
import { useHooks } from "hooks";
import useStore from "store";

const NotFound = () => {
  const { navigate } = useHooks();
  const { system } = useStore((state) => state);

  return (
    <div>
      <div className="flex align-center items-center flex-col justify-between">
        Not found!
        <Button
          title="Back Home"
          size="large"
          onClick={() => navigate("/")}
          className="px-[28px] py-[22px] mt-[40px]"
        />
      </div>
    </div>
  );
};

export default NotFound;
